import { Routes } from '@angular/router';
import { LoginComponent } from '@app/pages/auth/login/login.component';
import { RedirectComponent } from '@app/pages/auth/redirect/redirect.component';
import { SetPasswordComponent } from '@app/pages/auth/set-password/set-password.component';
import { PrivateComponent } from '@app/pages/private/private.component';

export const AppRoutes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  { path: 'set-password', component: SetPasswordComponent },
  { path: 'token-verify', component: RedirectComponent },

  {
    path: 'sapphire',
    component: PrivateComponent,
    data: { title: 'Sapphire' },
    loadChildren: () => import('./private.route').then((m) => m.PrivateRoutes),
  },
];
